import { makeObservable, observable } from 'mobx';
import { IModel, Model } from '.';
import { IdexxSpeciesModel, IIdexxSpeciesModel } from './IdexxSpeciesModel';

export interface ISpeciesModel extends IModel {
  speciesId: number;
  name: string;
  idexxSpeciesId?: number;
  idexxSpecies?: IIdexxSpeciesModel;
  allowUnknownGender?: boolean;
}
export class SpeciesModel extends Model implements ISpeciesModel {
  @observable speciesId: number;
  @observable name: string;
  @observable allowUnknownGender?: boolean | undefined;
  @observable idexxSpeciesId?: number | undefined;
  @observable idexxSpecies?: IdexxSpeciesModel | undefined;

  constructor(params: Partial<ISpeciesModel> = {} as ISpeciesModel) {
    super(params);
    const { speciesId = 0, name = '', allowUnknownGender = false } = params;

    this.speciesId = speciesId;
    this.name = name;
    this.allowUnknownGender = allowUnknownGender;
    // Do not default these fields, when creating a pet, a user will never fill them out and add idexx values.
    this.idexxSpeciesId = params.idexxSpeciesId;
    this.idexxSpecies = params.idexxSpecies
      ? new IdexxSpeciesModel(params.idexxSpecies)
      : undefined;
    makeObservable(this);
  }
}
